import { createTuyau } from '@tuyau/core/client'
import { createTuyauReactQueryClient } from '@tuyau/react-query'
import { registry } from 'gozoki-backend/registry'
import { getToken } from '~/utils/api'

export const tuyauClient = createTuyau({
  baseUrl: import.meta.env.VITE_BACKEND_API_ENDPOINT,
  registry,
  headers: {
    'Content-Type': 'application/json',
  },
  hooks: {
    beforeRequest: [
      async (request) => {
        const token = await getToken()
        if (token) request.headers.set('Authorization', `Bearer ${token}`)
      },
    ],
  },
})

export const api = createTuyauReactQueryClient({ client: tuyauClient })
